import React from 'react';

// IU crimson is fixed brand colour — it must not shift with the UI mode.
const IU_CRIMSON = '#990000';

/**
 * Indiana University School of Medicine lockup, drawn inline so it has no
 * baked-in white background and the wordmark can follow the active theme.
 *
 * The trident block keeps IU crimson in both modes; the wordmark and the
 * divider rule inherit `currentColor`, so set `color` on the wrapper (or let
 * it inherit from `text.primary`) to theme it.
 *
 * NOTE: this is a hand-built reconstruction of the lockup. If you have access
 * to the official vector from brand.iu.edu, drop it in and keep the same
 * currentColor treatment on the wordmark.
 */
const IULogo = ({ height = 48, title = 'Indiana University School of Medicine', ...props }) => (
    <svg
        viewBox="0 0 246 48"
        height={height}
        width={height * (246 / 48)}
        role="img"
        aria-label={title}
        focusable="false"
        style={{ display: 'block', flexShrink: 0 }}
        {...props}
    >
        <title>{title}</title>

        {/* Crimson block with the IU trident */}
        <rect x="0" y="2" width="36" height="44" fill={IU_CRIMSON} />
        <path
            fill="#ffffff"
            d="M10 12h4.6v10.4h3.1V12h4.6v10.4h3.1V12H30v13.6h-9.7v10.2h3.4V40h-11.4v-4.2h3.4V25.6H10V12z"
        />

        {/* Hairline rule between mark and wordmark */}
        <rect x="46" y="7" width="1" height="34" fill="currentColor" opacity="0.28" />

        {/* Wordmark — inherits colour from the surrounding text */}
        <text
            x="58"
            y="24"
            fill="currentColor"
            fontFamily='"Public Sans", "Helvetica Neue", Helvetica, Arial, sans-serif'
            fontSize="17"
            fontWeight="700"
            letterSpacing="0.2"
            dominantBaseline="middle"
        >
            INDIANA UNIVERSITY
        </text>
        <text
            x="58"
            y="39"
            fill="currentColor"
            opacity="0.72"
            fontFamily='"Public Sans", "Helvetica Neue", Helvetica, Arial, sans-serif'
            fontSize="12"
            fontWeight="400"
            letterSpacing="0.9"
            dominantBaseline="middle"
        >
            SCHOOL OF MEDICINE
        </text>
    </svg>
);

export default IULogo;
